export const ONLY_NUMBER_REGEX = /^[0-9]*$/;
export const EMAIL_ID_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const NUM_DECIMAL_REGEX = /^[0-9]\d*(\.\d+)?$/;
// export const PHONE_NUMBER_REGEX = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
export const PHONE_NUMBER_REGEX = /^[0][1-9]\d{9}$|^[1-9]\d{9}$/;
export const GENERIC_PHONE_NUMBER_REGEX =
  /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
export const URL_REGEX =
  /^([Hh][Tt][Tt][Pp][Ss]:|[Hh][Tt][Tt][Pp]:|[Ww][Ww][Ww].)/;
